import { Box, Text, FormLabel } from '@podiumhq/design-system';
import styled from 'styled-components/macro';
import { MEDIUM_MEDIA_QUERY_WIDTH } from '../../styles';
import { TRIAL_COLORS } from '../../screens/Trials/styles';

export const Subheading = styled(Text)`
  padding-bottom: 24px;
  font-size: 14px;
  line-height: 21px;

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    margin-top: 16px;
    margin-bottom: 24px;
    padding-bottom: 0;
  }
`;

export const ButtonWrapper = styled(Box)`
  button {
    margin-left: auto;

    @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
      width: 100%;
    }
  }
`;

export const TrialInputWrapper = styled(Box)`
  margin-bottom: 24px;
  position: relative;

  input {
    border-radius: 10px;
  }

  ${FormLabel},
  label span {
    color: ${TRIAL_COLORS.darkText};
  }

  &:last-child {
    margin-bottom: 0;
  }

  /* hide number input arrows */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  /* hide password icon on edge */
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
`;

export const multiStepInputStyles = {
  borderColor: '#ADB6BE',
  size: 'md',
  variant: 'outline',
};

export const trialTitleStyles = {
  fontSize: '3xl',
  fontWeight: 'semibold',
  mb: '16px',
};

export const trialButtonStyles = {
  borderRadius: '10px',
  fontSize: '17px',
  height: '40px',
  mt: '32px',
  padding: '7px 16px',
  sx: { _disabled: { opacity: 1 } },
  textShadow: '0 1px 1px rgba(0, 0, 0, 0.08)',
};

export const centerPageViewContentStyles = {
  margin: '0 auto',
  maxWidth: '400px',
};

export const contentBoxMobileProps = {
  borderRadius: '0',
  boxShadow: 'none',
  position: 'relative',
  top: '0',
  transform: 'none',
  width: '100%',
};
